export default __webpack_public_path__ + "static/media/Shield of the Soul Eater.e2537519.jpg";